import { render, staticRenderFns } from "./classParams.vue?vue&type=template&id=042628d7"
import script from "./classParams.vue?vue&type=script&lang=js"
export * from "./classParams.vue?vue&type=script&lang=js"
import style0 from "./classParams.vue?vue&type=style&index=0&id=042628d7&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports